import {Map, fromJS, List} from "immutable";

import {
    GET_SALES_STATS_SUCCESS,
    GET_SALES_STATS_REQUEST,
    GET_SALES_STATS_ERROR,

    GET_PURCHASES_STATS_SUCCESS,
    GET_PURCHASES_STATS_REQUEST,
    GET_PURCHASES_STATS_ERROR,

    CLEAN_STATS
} from '../actions/stats';

const stats = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState;
  switch (action.type) {

      // Requests
      case GET_SALES_STATS_REQUEST:
      case GET_PURCHASES_STATS_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_SALES_STATS_SUCCESS:
      case GET_PURCHASES_STATS_SUCCESS:
      case CLEAN_STATS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_SALES_STATS_ERROR:
      case GET_PURCHASES_STATS_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default stats;



// WEBPACK FOOTER //
// ./src/reducers/stats.js